/** Map Shopify product id -> auction id for predictive product links (live preferred over past). */
(function () {
  var CACHE_TTL_MS = 45000;
  var apiCache = { livePayload: null, pastPayload: null, liveTime: 0, pastTime: 0 };

  function pickArray(p) {
    return Array.isArray(p?.items)
      ? p.items
      : Array.isArray(p?.data)
        ? p.data
        : Array.isArray(p)
          ? p
          : Array.isArray(p?.data?.data)
            ? p.data.data
            : [];
  }
  function attr(it, k) {
    return it && it.attributes ? it.attributes[k] : it ? it[k] : undefined;
  }
  function productNumericId(platformProductId) {
    if (platformProductId == null || platformProductId === '') return '';
    var s = String(platformProductId).trim();
    if (s.indexOf('/') !== -1) return (s.split('/').pop() || '').trim();
    return String(s.replace(/\D/g, '') || s);
  }
  function normalizeProductPath(u) {
    if (!u) return '';
    var s = String(u);
    try {
      var parsed = /^https?:\/\//i.test(s) ? new URL(s) : new URL(s, window.location.origin);
      return (parsed.pathname.replace(/\/+$/, '') || '/');
    } catch (e) {
      return (s.split('?')[0].split('#')[0]).replace(/\/+$/, '') || '/';
    }
  }
  function stripLeadingLocaleSegment(pathN) {
    if (!pathN) return '';
    var p = pathN.replace(/\/+$/, '') || '/';
    var m = p.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?)\/(.*)$/i);
    if (m && m[1]) return ('/' + m[1]).replace(/\/+$/, '') || '/';
    return p;
  }
  function canonicalProductPath(u) {
    return stripLeadingLocaleSegment(normalizeProductPath(u));
  }
  function buildIdByCanonicalPath() {
    var idByPath = {};
    document.querySelectorAll('ul.urls-check-cards-products li[data-href][data-product-id]').forEach(function (li) {
      var href = li.getAttribute('data-href') || '';
      var mapPid = productNumericId(li.getAttribute('data-product-id'));
      if (!mapPid) return;
      var cp = canonicalProductPath(href);
      if (cp) idByPath[cp] = String(mapPid);
    });
    return idByPath;
  }
  function normalizeSku(s) {
    return String(s || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '');
  }
  /** Lot-style codes (e.g. M0694-12); free-text queries skip SKU gating. */
  function looksLikeSkuQuery(q) {
    var t = String(q || '').trim();
    if (t.length < 4) return false;
    if (/^[A-Za-z]{1,4}\d{3,}-\d+/i.test(t)) return true;
    if (/^\d{3,}-\d+$/.test(t)) return true;
    return false;
  }
  function skuGatePass(searchTerm, rowSku) {
    if (!looksLikeSkuQuery(searchTerm)) return true;
    var rs = normalizeSku(rowSku);
    if (!rs) return true;
    return normalizeSku(searchTerm) === rs;
  }
  function filterLiveRows(list) {
    var now = Date.now();
    return list.filter(function (row) {
      var a = row.attributes || row;
      var status = String(a.status || '').toLowerCase();
      var sd = Date.parse(a.start_date || a.start_at || '');
      var ed = Date.parse(a.end_date || a.end_at || '');
      return (
        isFinite(sd) &&
        isFinite(ed) &&
        sd <= now &&
        now < ed &&
        !/disabled|ended|archive|complete|cancel/.test(status)
      );
    });
  }
  function liveAuctionIdByProductId(payload) {
    var seen = {};
    var map = {};
    filterLiveRows(pickArray(payload)).forEach(function (row) {
      var a = row.attributes || row;
      var pid = productNumericId(a.platform_product_id);
      if (!pid || seen[pid]) return;
      seen[pid] = true;
      var aid = (row && row.id) || a.auction_id || a.id;
      if (aid == null) return;
      var sku = String(attr(row, 'product_sku') || a.product_sku || '').trim();
      map[String(pid)] = { id: String(aid), sku: sku };
    });
    return map;
  }
  function pastRowEndMs(row) {
    var a = row.attributes || row;
    var t = Date.parse(a.end_date || a.end_at || a.ended_at || a.closed_at || '');
    return isFinite(t) ? t : 0;
  }
  function pastRowAuctionIdNum(row) {
    var a = row.attributes || row;
    var raw =
      row && row.id != null && row.id !== ''
        ? row.id
        : a.auction_id != null && a.auction_id !== ''
          ? a.auction_id
          : a.id;
    var n = parseInt(String(raw).replace(/\D/g, ''), 10);
    return isFinite(n) ? n : 0;
  }
  function pastRowShouldReplace(incumbent, candidate) {
    if (!incumbent) return true;
    var cEnd = pastRowEndMs(candidate);
    var iEnd = pastRowEndMs(incumbent);
    if (cEnd !== iEnd) return cEnd > iEnd;
    return pastRowAuctionIdNum(candidate) > pastRowAuctionIdNum(incumbent);
  }
  function pastAuctionIdByProductId(payload) {
    var byRow = {};
    pickArray(payload).forEach(function (row) {
      var pid = productNumericId(attr(row, 'platform_product_id'));
      if (!pid) return;
      var k = String(pid);
      if (pastRowShouldReplace(byRow[k], row)) byRow[k] = row;
    });
    var map = {};
    Object.keys(byRow).forEach(function (k) {
      var row = byRow[k];
      var a = row.attributes || row;
      var aid = (row && row.id) || a.auction_id || a.id;
      if (aid == null) return;
      var sku = String(attr(row, 'product_sku') || a.product_sku || '').trim();
      map[k] = { id: String(aid), sku: sku };
    });
    return map;
  }

  function fetchAuctionPayloads() {
    var API_BASE = (window.staAuctionsBase ? window.staAuctionsBase() : localStorage.getItem('sterlings_base_url') || '').replace(/\/+$/, '');
    var headers = window.staAuctionHeaders ? window.staAuctionHeaders() : { Accept: 'application/json' };
    var now = Date.now();
    var tasks = [];
    if (!apiCache.livePayload || now - apiCache.liveTime > CACHE_TTL_MS) {
      tasks.push(
        fetch(API_BASE + '/api/auctions', { headers: headers, mode: 'cors', credentials: 'omit' })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          })
      );
    } else {
      tasks.push(Promise.resolve(null));
    }
    if (!apiCache.pastPayload || now - apiCache.pastTime > CACHE_TTL_MS) {
      tasks.push(
        (window.staFetchPastAuctionsPayload
          ? window.staFetchPastAuctionsPayload()
          : fetch(API_BASE + '/api/auctions', { headers: headers, mode: 'cors', credentials: 'omit' })
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (payload) {
                if (!payload) return null;
                var rows = window.staFilterPastAuctionRows
                  ? window.staFilterPastAuctionRows(window.staPickAuctionArray(payload))
                  : (payload.data || []);
                return { data: rows };
              })
        ).catch(function () {
          return null;
        })
      );
    } else {
      tasks.push(Promise.resolve(null));
    }
    return Promise.all(tasks).then(function (results) {
      if (results[0]) {
        apiCache.livePayload = results[0];
        apiCache.liveTime = Date.now();
      }
      if (results[1]) {
        apiCache.pastPayload = results[1];
        apiCache.pastTime = Date.now();
      }
      return {
        liveMap: liveAuctionIdByProductId(apiCache.livePayload),
        pastMap: pastAuctionIdByProductId(apiCache.pastPayload),
      };
    });
  }

  window.__staEnrichPredictiveProductLinks = function (rootEl, ref, searchTerm) {
    if (!rootEl) return Promise.resolve();
    var links = rootEl.querySelectorAll('#predictive-search-results a[href*="/products/"]');
    if (!links.length) return Promise.resolve();
    var idByPath = buildIdByCanonicalPath();
    var q = String(searchTerm || '').trim();
    return fetchAuctionPayloads().then(function (maps) {
      if (ref && ref.component && ref.component._auctionEnrichGen !== ref.startGen) return;
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        var href = a.getAttribute('href') || '';
        if (href.indexOf('auction_id=') !== -1) continue;
        var cp = canonicalProductPath(href);
        var pid = idByPath[cp];
        if (!pid) continue;
        var liveEntry = maps.liveMap[pid];
        var pastEntry = maps.pastMap[pid];
        var aid = null;
        if (liveEntry && skuGatePass(q, liveEntry.sku)) aid = liveEntry.id;
        if (!aid && pastEntry && skuGatePass(q, pastEntry.sku)) aid = pastEntry.id;
        if (!aid) continue;
        try {
          var u = new URL(href, window.location.origin);
          u.searchParams.set('auction_id', aid);
          var out = u.pathname + u.search + (u.hash || '');
          a.setAttribute('href', out);
        } catch (e) {}
      }
    });
  };
})();

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this._auctionEnrichGen = 0;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    // Default Shopify predictive fields omit variants.sku — full search uses options[prefix]=last for SKUs.
    // Include SKU (and related) so lot codes like M0694-12 surface in suggestions. See:
    // https://shopify.dev/docs/api/ajax/reference/predictive-search
    const predictiveParams = new URLSearchParams();
    predictiveParams.set('q', searchTerm);
    predictiveParams.set('section_id', 'predictive-search');
    predictiveParams.set(
      'resources[options][fields]',
      'title,product_type,variants.title,vendor,variants.sku,tag,variants.barcode'
    );

    fetch(`${routes.predictive_search_url}?${predictiveParams.toString()}`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();

    var gen = ++this._auctionEnrichGen;
    var enrichRef = { startGen: gen, component: this };
    if (typeof window.__staEnrichPredictiveProductLinks === 'function') {
      window.__staEnrichPredictiveProductLinks(this.predictiveSearchResults, enrichRef, this.searchTerm).catch(
        function () {}
      );
    }
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
